import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { TeamState } from './types';

const selectCache = (state: RootState) => state.teamCache;

export const selectCurrentTeamId = createSelector(
  selectCache,
  (cache: TeamState) => cache.currentTeamId
);

export const selectCurrentTeamName = createSelector(
  selectCache,
  (cache: TeamState) => cache.currentTeamName
);

export const selectCurrentTeamBaseMapType = createSelector(
  selectCache,
  (cache: TeamState) => cache.currentTeamBaseMapType
);

export const selectCurrentTeamBaseMapId = createSelector(
  selectCache,
  (cache: TeamState) => cache.currentTeamBaseMapId
);

export const selectCurrentTeamBaseMapToken = createSelector(
  selectCache,
  (cache: TeamState) => cache.currentTeamBaseMapToken
);

export const selectCustomBaseMapKey = createSelector(
  selectCache,
  (cache: TeamState) => cache.customBaseMapKey
);

export const selectCustomBaseMapSecret = createSelector(
  selectCache,
  (cache: TeamState) => cache.customBaseMapSecret
);

export const selectCurrentTeamShape = createSelector(
  selectCache,
  (cache: TeamState) => cache.currentTeamShape
);

export const selectTeamPickerDisabled = createSelector(
  selectCache,
  (cache: TeamState) => cache.teamPickerDisabled
);

export const selectTeamsList = createSelector(
  selectCache,
  (cache: TeamState) => cache.teamsList
);

export const selectLoadingTeamsList = createSelector(
  selectCache,
  (cache: TeamState) => cache.loadingTeamsList
);

export const selectTeamBoundaryToggle = createSelector(
  selectCache,
  (cache: TeamState) => cache.toggleTeamBoundary
);

export const selectCurrentTeamCreateEnquiryDefaultValues = createSelector(
  selectCache,
  (cache: TeamState) => cache.currentTeamDefaultValues
);
